import { render } from "./Contact.vue?vue&type=template&id=05cd565c"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=05cd565c&lang=scss"
script.render = render

export default script